import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styles from './AddBankStandalone.scss';
import {
  ADD_BANK_MODAL,
  openModal,
} from '../../../redux/modules/modals/modals.module';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import {
  getHasErrorType,
  getErrorType,
} from '../../../redux/modules/linkedBanks/linkBank.selectors';
import If from '../../../components/Shared/If/If';
import NavigationContainer from '../../../containers/Navigation/NavigationContainer';

class AddBankStandalone extends Component {
  /* constructor(props) {
    super(props);
  } */

  componentDidMount() {
    const { openAddBankModal } = this.props;
    openAddBankModal();
  }

  render() {
    const { getHasErrorType, getErrorType } = this.props;
    return (
      <>
        <If test={getHasErrorType}>
          <NavigationContainer />
        </If>
        <FullPageLoader
          isVisible={false}
          errorType={getErrorType}
          hasError={getHasErrorType}
        />
        <div className={styles.placeholder} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getHasErrorType: getHasErrorType(state),
    getErrorType: getErrorType(state),
  };
};
const mapDispatchToProps = (dispatch) => ({
  openAddBankModal: () => dispatch(openModal(ADD_BANK_MODAL)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AddBankStandalone
);
